const users = {
    page_title: '사용자 관리',
    title: '사용자 관리',
    subtitle: '사용자의 신원을 추가, 삭제, 수정, 조회하여 관리해보세요.',
    create: '사용자 추가',
    create_subtitle: '다음 중 적어도 하나의 필드를 제공해주세요.',
    error_missing_identifier: '사용자를 생성하려면 적어도 하나의 식별자를 제공해야 합니다.',
    user_name: '사용자',
    application_name: '어플리케이션으로부터',
    latest_sign_in: '최근 로그인 시각',
    create_form_username: '사용자 이름',
    create_form_password: '비밀번호',
    create_form_name: '이름',
    placeholder_name: '홍길동',
    placeholder_email: 'honggildong@example.com',
    placeholder_username: 'user123',
    placeholder_phone: '+82 2-1234-5678',
    unnamed: '이름없음',
    search: '이름, 이메일, 전화번호, ID로 검색',
    check_user_detail: '사용자 상세정보 확인',
    placeholder_title: '사용자 관리',
    placeholder_description: '각 사용자에게는 모든 사용자 정보가 포함된 프로필이 있어요. 프로필은 기본 데이터, 소셜 인증, 사용자 지정 데이터로 구성돼요.',
    dev_tenant_data_retention_notice: '개발 테넌트에서는 90일이 지난 사용자 계정이 자동으로 삭제됩니다. <a>자세히 알아보기</a>',
};
export default Object.freeze(users);
